import {
    IOnBookingCreatedNotificationSetup,
    IOnBookingCreationFailedNotificationSetup,
    IOnOfferSelectedNotificationSetup
} from "libraries/service/resources/model/booking/air/IAirCreateBooking";
import { IMargin } from "libraries/service/resources/booking/interfaces/IGetBookings";

export enum CabinClasses {
    economy = 'Economy',
    ecoPremium = 'EcoPremium',
    business = 'Business',
    first = 'First'
}

export enum DurationViaUnits {
    minute = 'Minute',
    hour = 'Hour'
}

export enum FareTypes {
    public = 'Public',
    negoFare = 'NegoFare',
    tourOperator = 'TourOperator'
}

export enum Keywords {
    luggageInHold = 'LuggageInHold'
}

export interface IFlexibility {
    begin: {
        plusOrMinus: number;
    };
}

export interface IPricePlusOrMinus {
    percentage: number;
}

export interface IPrice {
    value?: number;
    plusOrMinus?: IPricePlusOrMinus;
    fareType?: FareTypes[];
    retailArray?: IPriceRetailItem[];
}

export interface IPriceRetailItem {
    xRole:EPriceRetailXRole;
    markup: IMargin;
    margin: IMargin;
}

export enum EPriceRetailXRole {
    Service = 'Service',
    Transportation = 'Transportation',
}

export interface IQuantity {
    adult: number;
    child: number;
    infant: number;
}

export interface ISegmentAirport {
    airport: {
        iata: string;
    };
}

export interface ISegmentBeginIntervalle {
    min?: string;
    max?: string;
}

export interface ISegmentBeginValue {
    value: string;
    between?: ISegmentBeginBetween;
}

export interface ISegmentBeginBetween {
    min?: ISegmentBeginBetweenMinMax;
    max?: ISegmentBeginBetweenMinMax;
}

export interface ISegmentBeginBetweenMinMax {
    time: string;
}

export interface ISegment {
    begin: string | ISegmentBeginValue | ISegmentBeginIntervalle;
    end?: {
        xMoment?: string,
        value?: string,
        between?: {
            min: {
                time: string
            },
            max: {
                time: string
            }
        }
    };
    viaArray?: Array<{
        duration: {
            max: number,
            xUnit: string
        }
    }>;
    cabin: string;
    from: string | ISegmentAirport;
    maxVias: number;
    to: string | ISegmentAirport;
}

export interface IBookingExternalLink {
    autoRedirect: boolean;
    openInNewWindow: boolean;
    addBookingArgsToURL?: boolean;
    addOfferArgsToURL?: boolean;
    link: string;
    quoteKey?: string;
    button: {
        text: string;
        show: boolean;
    };
}

export interface IPostAirSearchRequest {
    initialisationRequestContent?: IPostAirSearchRequest;
    languageCode?: string;
    carrier?: IPostAirSearchRequestCarrier;
    flexibility?: IFlexibility;
    host: string[];
    keyword?: Keywords[];
    price?: IPrice;
    quantity: IQuantity;
    segment: ISegment[];
    cabin?: CabinClasses;
    maxVias?: number;
    bookingExternalLink: IBookingExternalLink;
    traveller?: IPostAirSearchRequestTraveller[];
    onBookingCreatedNotificationArray: IOnBookingCreatedNotificationSetup[];
    onOfferSelectedNotificationArray: IOnOfferSelectedNotificationSetup[];
    onBookingCreationFailedNotificationArray: IOnBookingCreationFailedNotificationSetup[];
    externalContextId?: string;
    booking?: {
        title: string;
    };
}

export interface IPostAirSearchRequestTraveller {
    isReadonly: boolean;
    title: string;
    type: 'Adult'|'Infant'|'Child';
    firstName: string;
    lastName: string;
    birthDate: string;
}

export interface IPostAirSearchRequestCarrier {
    include?: string[];
}

export interface IPostAirSearchRequestCarrierInclude {
    iata: string;
}
